// COLLECTION MOBILE SORT ANCHOR
const mobSortAnc = [...document.querySelectorAll('.c-mob-sort__a')];

// COLLECTION PRODUCT SWATCHES LOGIC
const productSwatch = [...document.querySelectorAll('.collections__content__item__c__li--clr')];
const showMoreSwatches = [...document.querySelectorAll('.collections__content__item__c__li--cross')];

// ADDRESSES
const editLength = document.querySelectorAll('.edit-length');

// PRODUCT SWATCHES
let productColorRadio = document.querySelector('.product__item-c__cart-c__ul--js');
let productSize = document.querySelector('.product__item-c__cart-c__select');
const selectedColor = document.querySelector('.sel-color');

// NEWSLETTER
const newsLetter = document.querySelector('.pop');
const closeNewsLetter = [document.querySelector('.pop__c__close'), document.getElementById('close-letter')];
const newsLetterExpiry = getWithExpiry('newsletter');

// ACCOUNT PAGE DROPDOWN
const accountPageDrop = document.querySelector('.account__mobile-menu__ul__a');

// ADDRESS PAGE
const openEdit = document.querySelectorAll('.address__add__modify__edit');
const closeEdit = document.querySelectorAll('button[data-target]');
const deleteAddress = document.querySelectorAll('.address__add__modify__delete');
const openAddAddress = document.querySelector('.address__add__cont--center');
const addAddress = document.querySelector('.address__add__new');
const addressDropdown = document.querySelector('.address__mobile-menu__ul__a');

// FORGOT PASSWORD
const openPasswordPage = document.querySelector('.login__fpass');
const openLoginPage = document.querySelector('.a--forgot');
const loginPage = document.getElementById('login');
const forgotPage = document.getElementById('forgot-pas');

// CART UPSELL IS ACTIVE
const cartUpsellActive = document.querySelector('.cart__upsell');

// CART UPSELL AJAX
const cartUpsellForm = document.querySelector('.cart__upsell__grid-c');

// BURGER MENU
const burgerMenu = document.querySelector('.burger-menu');
const headerMobile = document.querySelector('.header-down-mobile');

// BURGER MENU ITEMS
const headerMobileItems = document.querySelectorAll('.header-down-mobile__li--has-sub');

// CLOSE BURGER MENU OPENED ITEM
const closeThis = document.querySelectorAll('.header-down-mobile-down__title-c__close');

// BODY
const rootBody = document.querySelector('body');

// PRODUCT FROM INCREASE OR DECREASE QUANTITY
const productQuantity = document.querySelector('.product__item-c__cart-c__quantity-c');

// PRODUCT PAGE AJAX
const productForm = document.querySelector('.product__item-c__cart-c__form');
const productUpSell = document.querySelector('.upsell-c');
const relatedProductsCont = document.querySelector('#shopify-section-product-recommendations');
const productUpSellAppend = document.querySelector('.upsell-c__ul');
let formProductId;
productUpSell ? formProductId= productUpSell.parentElement.dataset.productId: -1;

// SIDECART AJAX
// SIDECART UPDATE QUANTITY
const sideQuantityChange = document.querySelectorAll('.sidecart__pqt__price-c');

// SIDECART TBODY
const sideCartTbody = document.getElementById('side-tbody');

// CART TBODY // CART UPDATE QUANTITY  // CART REMOVE/DELETE LINE ITEM
const cartPageTbody = document.querySelector('.cart__table__tbody');

// UPDATE SUBTOTAL
let cartSubTotalMob = document.getElementById('sub-total-cart-mob');
let cartSubTotalDesk = document.getElementById('sub-total-cart');
let sideCartTotal = document.querySelectorAll('.sidecart__total-ck__total-p-c__total-p__tx')[1];
let cartQuantityDisplay = document.querySelector('.header__menu__links__cart-c__quantity');

// HEADER MENU NAV
const headerNav = document.querySelectorAll('.header__menu__ul__a');
const headerNavDown = document.querySelectorAll('.header-down');

// HTML ROOT
const root = document.querySelector('html');

// SEARCH 
const openSearch = document.getElementById('search');
const closeSearch = document.getElementById('search-close');
const searchMenu = document.querySelector('.search-down-c');

// PREDICTIVE SEARCH
const searchForm = document.getElementById('search-header');
const searchCont = document.querySelector('.search-down');
const searchDownResult = document.querySelector('.search-down__result');

// SEARCH MOBILE
const mobileSearch = document.getElementById('search-mobile');

// SIDECART
const miniCartOpen = document.getElementById('mini-cart');
const miniCartClose = document.getElementById('mini-cart-close');
const sideCart = document.querySelector('.sidecart');

// PAGE DROPDOWN
const pageMobileDrop = document.querySelector('.page-general__mobile-menu__ul__li');

// ACCORDION PAGE
const accordionItems = [...document.querySelectorAll('.accordion-c__item__flex')];

// ACCORDION FOOTER
const accordionFooter = document.querySelectorAll('.footer__menu__main-mobile__drop-menu');

// OVERLAY
const overlay = document.querySelector('.overlay');
const overlayHeader = document.querySelector('.overlay-header');

// COLLECTIONS SORT AND FILTER CLOSE MOBILE
const closeFilter = document.querySelector('.c-mob-filter__close');
const closeSort = document.querySelector('.c-mob-sort__close');

// COLLECTIONS SORT AND FILTER OPEN MOBILE
const openFilter = document.getElementById('c-mob-filter');
const openSort = document.getElementById('c-mob-sort');

// SELECT SORT
const SortSelect = document.querySelector('#SortBy');

rootBody.classList.remove('body-js');

if (Shopify && editLength.length > 0) {
      // eslint-disable-next-line no-new
  new Shopify.CountryProvinceSelector(
    'AddressCountryNew',
    'AddressProvinceNew',
    {
      hideElement: 'AddressProvinceContainerNew'
    }
  );

  editLength.forEach((el, index) => {
    new Shopify.CountryProvinceSelector(
      `AddressCountryNew${index}`,
      `AddressProvinceNew${index}`,
      {
        hideElement: `AddressProvinceContainerNew${index}`
      }
    );
  });
}

$('.product-slider').on('afterChange', function(){
  let dataElem = document.querySelector('.product-slider').querySelector('.slick-current');
  let productOptions = [];
  productOptions.push(dataElem.dataset.color);
  productOptions.push(dataElem.dataset.size);
  
  if(productColorRadio){
    productColorRadio.querySelectorAll('input[type="radio"]').forEach(el => {
      if(el.value ===  productOptions[0]){
        el.click();
      }
    });
  }

  if(productSize){
    [...productSize.options].forEach(el => {
      if(el.value === productOptions[1]){
        productSize.value = el.value;
      }
    });
  }
  
});

if(productColorRadio){
  productColorRadio.addEventListener('click', function(e){
    let liExist = e.target.parentElement.classList.contains('product__item-c__cart-c__li');
    if(!liExist) return;
    let productOptions = [];
    let theOne;
    let theOneIndex;
    let targetColor = e.target.parentElement.querySelector('label').dataset.color;
    let productSlide = document.querySelectorAll('.product-slider__li');
    productOptions.push(targetColor);
    productSize ? productOptions.push(productSize.value) : -1;
    selectedColor.textContent = targetColor;
    productSlide.forEach((el) => {
      if((el.dataset.color && el.dataset.size) && (el.dataset.color == productOptions[0] && el.dataset.size == productOptions[1])){
        theOne = el;
        theOneIndex = el.dataset.index;
      }else if((el.dataset.color && el.dataset.color == productOptions[0]) && !el.dataset.size){
        theOne = el;
        theOneIndex = el.dataset.index;
      }else if((el.dataset.size && el.dataset.size == productOptions[1]) && !el.dataset.color){
        theOne = el;
        theOneIndex = el.dataset.index;
      }
    });
    theOneIndex ? $('.product-slider').slick('slickGoTo', theOneIndex, false) : -1;
  });
}

if(productSize){
  productSize.addEventListener('change', function(){
    let productOptions = [];
    let theOne;
    let theOneIndex;
    let radioOptions = productColorRadio.querySelectorAll('input[type="radio"]');
    if(!radioOptions) return;
    let productSlide = document.querySelectorAll('.product-slider__li');
    radioOptions.forEach(el => {
      if(el.checked){
        productOptions.push(el.parentElement.querySelector('label').dataset.color);
      }
    });
    productOptions.push(this.value);
    productSlide.forEach((el) => {
      if((el.dataset.color && el.dataset.size) && (el.dataset.color == productOptions[0] && el.dataset.size == productOptions[1])){
        theOne = el;
        theOneIndex = el.dataset.index;
      }else if((el.dataset.color && el.dataset.color == productOptions[0]) && !el.dataset.size){
        theOne = el;
        theOneIndex = el.dataset.index;
      }else if((el.dataset.size && el.dataset.size == productOptions[1]) && !el.dataset.color){
        theOne = el;
        theOneIndex = el.dataset.index;
      }
    });

    theOneIndex ? $('.product-slider').slick('slickGoTo', theOneIndex, false) : -1;
  
  });
}

function setWithExpiry(key, value, ttl) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

if(newsLetter && window.innerWidth > 838){
  $(document).ready(function() {
    if(!newsLetterExpiry){
      newsLetter.classList.add('pop--show');
      overlay.classList.add('overlay--open');
      setWithExpiry('newsletter', 'true', 3600000);
    }
  });
  closeNewsLetter.forEach(el => {
    el.addEventListener('click', function(){
      newsLetter.classList.remove('pop--show');
      overlay.classList.remove('overlay--open');
    });
  });
}

if(accountPageDrop){
  accountPageDrop.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    let targetUl = this.parentElement.parentElement.querySelector('.account__mobile-menu__ul__dropdown');
    targetUl.classList.toggle('account__mobile-menu__ul__dropdown--show');
  });
}

if(addressDropdown){
  addressDropdown.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    let targetUl = this.parentElement.parentElement.querySelector('.address__mobile-menu__ul__dropdown');
    targetUl.classList.toggle('address__mobile-menu__ul__dropdown--show');
  });
}

if(openAddAddress){
  openAddAddress.addEventListener('click', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    addAddress.classList.add('address__add__new--show');
    this.parentElement.parentElement.parentElement.classList.add('address__add__saved--hide');
  });
}

if(deleteAddress){
  deleteAddress.forEach(el => {
    el.addEventListener('click', function(e){
      e.stopImmediatePropagation();
      let target = this.dataset.target;
      Shopify.postLink(target, {'parameters': {'_method': 'delete'}});
    });
  });
}

if(openEdit){
  openEdit.forEach(el => {
    el.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let targetParent = el.parentElement.parentElement.parentElement;
      let thisParent = targetParent.parentElement.parentElement;
      let openThis = document.getElementById(`${targetParent.dataset.target}`);
      openThis.classList.add('address__add__edit--show');
      thisParent.classList.add('address__add__saved--hide');
    });
  });
}

if(closeEdit){
  closeEdit.forEach(el => {
    el.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let thisParent = this.parentElement.parentElement.parentElement;
      let openThis = document.querySelector('.address__add__saved');
      openThis.classList.remove('address__add__saved--hide');
      thisParent.classList.remove('address__add__edit--show');
      addAddress.classList.remove('address__add__new--show');
    });
  });
}

if(openPasswordPage){
  openPasswordPage.addEventListener('click', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    loginPage.classList.add('login--hide');
    forgotPage.classList.remove('login--hide');
  });
  
  openLoginPage.addEventListener('click', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    loginPage.classList.remove('login--hide');
    forgotPage.classList.add('login--hide');
  });
}

$('.about-5-slider').slick({
	arrows:false,
	infinite:true,
	slidesToShow:1,
	slidesToScroll:1,
	autoplay:false,
	autoplaySpeed:2000,
  dots:false,
  customPaging : function(slider, i) {
    return '';
  },
  responsive:[
    {
      breakpoint: 2000,
      settings: 'unslick'
    },
    {
      breakpoint: 720,
      settings: {
        infinite: true,
        dots: true,
        arrows:false
      }
    }
  ]
});

$('.cart__upsell__grid-c').slick({
  arrows:false,
  dots:false,
	infinite:true,
	slidesToShow:1,
	slidesToScroll:1,
  responsive:[
    {
      breakpoint: 2000,
      settings: 'unslick'
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow:1,
        slidesToScroll:1,
        dots: true,
        customPaging : function(slider, i) {
          return '';
        }
      }
    }
  ]
});

$('.upsell-c__ul').slick({
  arrows:true,
  dots:false,
	infinite:true,
	slidesToShow:1,
	slidesToScroll:1,
	prevArrow:$('.upsell-c__prev'),
  nextArrow:$('.upsell-c__next'),
  responsive:[
    {
      breakpoint: 600,
      settings: {
        arrows:false
      }
    }
  ]
});

if(closeThis){
  closeThis.forEach(item => {
    item.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      this.parentElement.parentElement.classList.remove('header-down-mobile-down--show');
    });
  })
}

if(headerMobileItems){
  headerMobileItems.forEach(items => {
    items.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let targetCollection = document.getElementById(`${this.dataset.target}`);
      targetCollection.classList.add('header-down-mobile-down--show');
    });
  })
}

if(burgerMenu){
  burgerMenu.addEventListener('click', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    let open = this.dataset.toggle;
    let burgerImages = [this.querySelector('.burger-menu__open'), this.querySelector('.burger-menu__close')];
    if(open === 'false'){
      this.dataset.toggle = 'true'
      burgerImages[0].classList.add('burger-menu__open--hide');
      burgerImages[1].classList.add('burger-menu__close--show');
      headerMobile.classList.add('header-down-mobile--show');
    }else{
      this.dataset.toggle = 'false'
      burgerImages[0].classList.remove('burger-menu__open--hide');
      burgerImages[1].classList.remove('burger-menu__close--show');
      headerMobile.classList.remove('header-down-mobile--show');
    }
  });
}

// PRODUCT FORM INCREASE OR DECREASE QUANTITY
if(productQuantity){
  productQuantity.addEventListener('click', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    let target = e.target.dataset.quantity;
    if(!target) return;
    let targetParent = e.target.parentElement;
    let targetInput = targetParent.querySelector('input');
    let quantityValue = targetInput.value;
    if(target === 'plus'){
      quantityValue <= 98 ? targetInput.value = + quantityValue + 1 : -1;
    }else{
      quantityValue > 1 ? targetInput.value = + quantityValue - 1: -1;
    }
  
  });
}

// PRODUCT FORM ADD TO CART
if(productForm){
  productForm.addEventListener('submit', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    let thisForm = this;

    let productQuantityEl = this.querySelector('.product__item-c__cart-c__input-quantity');
    let productQuantityValue;
        productQuantityEl ? productQuantityValue = productQuantityEl.value : productQuantityValue = 1;
    let defaultProductId = thisForm.querySelectorAll('input[type="hidden"]')[2].value;

    // BUTTONS
    let buttonCart = thisForm.querySelector('.btns--cart');
    let buttonCartTx = thisForm.querySelector('.product__item-c__cart-c__cart-tx');
    let spinnerImg = thisForm.querySelector('.product__item-c__cart-c__cart-img--spinner');
    let cartImg = thisForm.querySelector('.product__item-c__cart-c__cart-img--cart');
    let addedImg = thisForm.querySelector('.product__item-c__cart-c__cart-img--added');

    let radioItems = [...this.querySelectorAll('.product__item-c__cart-c__input--clr-js')];
    let checkedRadio;
    let selectItems = this.querySelector('.product__item-c__cart-c__select');
    let selectValue;
        selectItems ? selectValue = selectItems.value: -1;
    let giftCardItem = this.querySelector('.gc__select');
    let giftCardValue;
        giftCardItem ? giftCardValue = giftCardItem.value: -1;
    let productHandle = this.dataset.handle;
    let getProductId;
    if(radioItems.length > 0){
      checkedRadio = radioItems.map(el => {return el.checked ? el : undefined;}).filter(el => el !== undefined)[0].dataset.color;
    }
    let addItems;
    // UPSELL
    let upsellInclude = [...thisForm.querySelectorAll('.upsell-c__li__content-c__include-c__input')].filter(el => el.checked);
    let upsellParentElement = [...upsellInclude].map(el => el.parentElement.parentElement.parentElement.parentElement);
    let upsellProductHandles = [...new Set(upsellParentElement.map(el => el.dataset.productHandle).filter(el => el !== undefined))];
    let upsellSelectedProductVariantIds = [];
    if(upsellInclude.length > 0){
      upsellParentElement.forEach((el,index) => {
        let elVariantColor = el.querySelector('.upsell-c__li__content-c__select--color');
        let elVariantSize = el.querySelector('.upsell-c__li__content-c__select--size');
        let variantColor;
        let variantSize;
        elVariantColor ? variantColor = elVariantColor.value : -1;
        elVariantSize ? variantSize = elVariantSize.value : -1;
        $.ajax({
          method:'GET',
          url:`/products/${upsellProductHandles[index]}`,
          dataType:'json'
        })
        .done(res => {
          if(elVariantColor && elVariantSize){
            upsellSelectedProductVariantIds[index] = res.product.variants.find(item => {
              if(item.option1 === variantColor && item.option2 === variantSize){
                return item;
              }}).id;
          }else if(elVariantColor){
            upsellSelectedProductVariantIds[index] = res.product.variants.find(item => {
              if(item.option1 === variantColor){
                return item;
              }}).id;
          }else if(elVariantSize){
            upsellSelectedProductVariantIds[index] = res.product.variants.find(item => {
              if(item.option2 === elVariantSize){
                return item;
              }}).id
          }
          $.ajax({
            method:'GET',
            url:`/products/${productHandle}`,
            dataType:'json'
          })
          .done(function(res){
            if(checkedRadio && selectValue){
              getProductId = res.product.variants.find(item => {
                let itemTitle = item.title.toLowerCase();
                let radioValue = checkedRadio.toString().toLowerCase();
                let selValue = selectValue.toString().toLowerCase();
                if(itemTitle.includes(radioValue) && itemTitle.includes(selValue)){
                  return item;
                }
              }).id;
            }else if(checkedRadio){
              getProductId = res.product.variants.find(item => {  
                let itemTitle = item.title.toLowerCase();
                let radioValue = checkedRadio.toString().toLowerCase();
                if(itemTitle.includes(radioValue)){
                  return item;
                }}).id;
            }else if(selectValue){
              getProductId = res.product.variants.find(item => {  
                let itemTitle = item.title.toLowerCase();
                let selValue = selectValue.toString().toLowerCase();
                if(itemTitle.includes(selValue)){
                  return item;
                }}).id;
            }else if(giftCardItem){
              getProductId = res.product.variants.find(item => {  
                let itemTitle = item.title.toLowerCase();
                let giftValue = giftCardValue.toString().toLowerCase();
                if(itemTitle.includes(giftValue)){
                  return item;
                }}).id;
            }else{
              getProductId = defaultProductId;
            }
      
            buttonCart.classList.add('btns--cart-adding');
            buttonCartTx.textContent = 'Adding';
            cartImg.classList.add('product__item-c__cart-c__cart-img--hide');
            spinnerImg.classList.add('product__item-c__cart-c__cart-img--show');
            addItems = {items:[{quantity:productQuantityValue, id: getProductId}]};
            if(upsellSelectedProductVariantIds.length > 0){
              upsellSelectedProductVariantIds.forEach((item, index) => {
                addItems.items[index+1] = {quantity:'1', id:+item}
              });
            }
              $.ajax({
                method:'POST',
                url:'/cart/add.js',
                data:addItems,
                dataType: 'json'
              })
              .done(function(res){
                spinnerImg.classList.remove('product__item-c__cart-c__cart-img--show');
                spinnerImg.addEventListener('transitionend', function(){
                  buttonCartTx.textContent = 'Added';
                  addedImg.classList.add('product__item-c__cart-c__cart-img--show');
                  addedImg.addEventListener('transitionend', function(){
                    addedImg.classList.remove('product__item-c__cart-c__cart-img--show');
                    cartImg.classList.remove('product__item-c__cart-c__cart-img--hide');
                    buttonCart.classList.remove('btns--cart-adding');
                    buttonCartTx.textContent = 'Add to Cart';
                  });
                });
  
                sideCartTbody.insertAdjacentHTML('afterbegin',
                res.items.map(item => {
                  let elementExist = document.querySelector(`tr[data-item-id="${item.id}"]`);
                  if(!elementExist){
                    return `<tr data-item-id="${item.id}">
                <td class="sidecart__td">
                    <div class="grids grids--sidecart">
                        <div>
                            <div class="sidecart__img-c">
                                <a class="sidecart__img-c__a" href="${item.url}" aria-label="Product link">
                                    <img class="sidecart__img-c__a__img lazyload" src="${item.featured_image.url ? item.featured_image.url : '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_80x80.gif'}" alt="${item.featured_image.alt}">
                                </a>
                            </div>
                        </div>
                        <div>
                            <div class="sidecart__content-c">
                                <div class="sidecart__content-c__prod-c">
                                    <h6 class="sidecart__content-c__prod-c__title">${item.title}</h6>${item.options_with_values.map(options => { `<p class="p p--3">${options.name}:${options.value}</p>`}).join(' ')}</div>
                                <div class="sidecart__content-c__del-c">
                                    <a class="sidecart__content-c__del-c__a" data-delete="true" href="/cart/change?line=1&amp;quantity=0">
                                        <div class="sidecart__content-c__del-c__a__del-item">
                                            <img src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/trash-can.svg?v=1772481377807784557" alt="Remove">
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="sidecart__pqt">
                                <p class="p p--cart-price">${theme.Currency.formatMoney(item.price)}</p>
                                <div class="sidecart__pqt__price-c">
                                    <button class="sidecart__pqt__price-c__qty" data-quantity="minus" aria-label="Reduce item quantity by one"><img class="sidecart__pqt__price-c__qty__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-minus.svg?v=7052878514306531202" alt="Reduce item quantity by one"></button>
                                    <input class="sidecart__pqt__price-c__input" aria-label="product quantity" type="number" min="1" max="99" value="${item.quantity}">
                                    <button class="sidecart__pqt__price-c__qty" data-quantity="plus" aria-label="Increase item quantity by one"><img class="sidecart__pqt__price-c__qty__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-plus.svg?v=1527990585671600354" alt="Increase item quantity by one"></button>
                                </div>
                                <p class="p p--cart-total">${theme.Currency.formatMoney(item.final_line_price)}</p>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>`
                  }else{
                    let totalPrice = elementExist.querySelector('.p--cart-total');
                    let itemQuantity = elementExist.querySelector('input[type="number"]');
                    totalPrice.textContent = theme.Currency.formatMoney(item.final_line_price);
                    itemQuantity.value = item.quantity;
                  }
                }).join(' ')
            );
      
            $.ajax({
              method:'GET',
              url:'/cart.js',
              dataType:'json'
            })
            .done(function(res){
              updateSubtotal(res);
            });
                
              })
              .fail(function(err){
                spinnerImg.addEventListener('transitionend', function(){
                  spinnerImg.classList.remove('product__item-c__cart-c__cart-img--show');
                  buttonCart.classList.remove('btns--cart-adding');
                  cartImg.classList.remove('product__item-c__cart-c__cart-img--hide');
                  buttonCartTx.textContent = 'Add to Cart';
                });
              });
          });
        });
      });
    }else{
      $.ajax({
        method:'GET',
        url:`/products/${productHandle}`,
        dataType:'json'
      })
      .done(function(res){
        if(checkedRadio && selectValue){
          getProductId = res.product.variants.find(item => {
            let itemTitle = item.title.toLowerCase();
            let radioValue = checkedRadio.toString().toLowerCase();
            let selValue = selectValue.toString().toLowerCase();
            if(itemTitle.includes(radioValue) && itemTitle.includes(selValue)){
              return item;
            }
          }).id;
        }else if(checkedRadio){
          getProductId = res.product.variants.find(item => {  
            let itemTitle = item.title.toLowerCase();
            let radioValue = checkedRadio.toString().toLowerCase();
            if(itemTitle.includes(radioValue)){
              return item;
            }}).id;
        }else if(selectValue){
          getProductId = res.product.variants.find(item => {  
            let itemTitle = item.title.toLowerCase();
            let selValue = selectValue.toString().toLowerCase();
            if(itemTitle.includes(selValue)){
              return item;
            }}).id;
        }else if(giftCardItem){
          getProductId = res.product.variants.find(item => {  
            let itemTitle = item.title.toLowerCase();
            let giftValue = giftCardValue.toString().toLowerCase();
            if(itemTitle.includes(giftValue)){
              return item;
            }}).id;
        }else{
          getProductId = defaultProductId;
        }
    
        buttonCart.classList.add('btns--cart-adding');
        buttonCartTx.textContent = 'Adding';
        cartImg.classList.add('product__item-c__cart-c__cart-img--hide');
        spinnerImg.classList.add('product__item-c__cart-c__cart-img--show');
        addItems = {items:[{quantity:productQuantityValue, id: getProductId}]};
      
          $.ajax({
            method:'POST',
            url:'/cart/add.js',
            data:addItems,
            dataType: 'json'
          })
          .done(function(res){
            spinnerImg.classList.remove('product__item-c__cart-c__cart-img--show');
            spinnerImg.addEventListener('transitionend', function(){
              buttonCartTx.textContent = 'Added';
              addedImg.classList.add('product__item-c__cart-c__cart-img--show');
              addedImg.addEventListener('transitionend', function(){
                addedImg.classList.remove('product__item-c__cart-c__cart-img--show');
                addedImg.addEventListener('transitionend', function(){
                  cartImg.classList.remove('product__item-c__cart-c__cart-img--hide');
                  buttonCart.classList.remove('btns--cart-adding');
                  buttonCartTx.textContent = 'Add to Cart';
                });
              });
            });
            sideCartTbody.insertAdjacentHTML('afterbegin',
            res.items.map(item => {
              let elementExist = document.querySelector(`tr[data-item-id="${item.id}"]`);
              if(!elementExist){
                return `<tr data-item-id="${item.id}">
            <td class="sidecart__td">
                <div class="grids grids--sidecart">
                    <div>
                        <div class="sidecart__img-c">
                            <a class="sidecart__img-c__a" href="${item.url}">
                                <img class="sidecart__img-c__a__img lazyload" src="${item.featured_image.url ? item.featured_image.url : '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_80x80.gif'}" alt="${item.featured_image.alt}">
                            </a>
                        </div>
                    </div>
                    <div>
                        <div class="sidecart__content-c">
                            <div class="sidecart__content-c__prod-c">
                                <h6 class="sidecart__content-c__prod-c__title">${item.title}</h6>${item.options_with_values.map(options => { `<p class="p p--3">${options.name}:${options.value}</p>`}).join(' ')}</div>
                            <div class="sidecart__content-c__del-c">
                                <a class="sidecart__content-c__del-c__a" data-delete="true" href="/cart/change?line=1&amp;quantity=0">
                                    <div class="sidecart__content-c__del-c__a__del-item">
                                        <img src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/trash-can.svg?v=1772481377807784557" alt="Remove">
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="sidecart__pqt">
                            <p class="p p--cart-price">${theme.Currency.formatMoney(item.price)}</p>
                            <div class="sidecart__pqt__price-c">
                                <button class="sidecart__pqt__price-c__qty" data-quantity="minus" aria-label="Reduce item quantity by one"><img class="sidecart__pqt__price-c__qty__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-minus.svg?v=7052878514306531202" alt="Reduce item quantity by one"></button>
                                <input class="sidecart__pqt__price-c__input" type="number" min="1" max="99" value="${item.quantity}">
                                <button class="sidecart__pqt__price-c__qty" data-quantity="plus" aria-label="Increase item quantity by one"><img class="sidecart__pqt__price-c__qty__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-plus.svg?v=1527990585671600354" alt="Increase item quantity by one"></button>
                            </div>
                            <p class="p p--cart-total">${theme.Currency.formatMoney(item.final_line_price)}</p>
                        </div>
                    </div>
                </div>
            </td>
        </tr>`
              }
              else{
                let totalPrice = elementExist.querySelector('.p--cart-total');
                let itemQuantity = elementExist.querySelector('input[type="number"]');
                totalPrice.textContent = theme.Currency.formatMoney(item.final_line_price);
                itemQuantity.value = item.quantity;
              }
            }).join(' ')
        );
    
        $.ajax({
          method:'GET',
          url:'/cart.js',
          dataType:'json'
        })
        .done(function(res){
          updateSubtotal(res);
        });
            
          })
          .fail(function(err){
            spinnerImg.addEventListener('transitionend', function(){
              spinnerImg.classList.remove('product__item-c__cart-c__cart-img--show');
              buttonCart.classList.remove('btns--cart-adding');
              cartImg.classList.remove('product__item-c__cart-c__cart-img--hide');
              buttonCartTx.textContent = 'Add to Cart';
            });
          });
      });
    }
  });
}

// PRODUCT FORM UPSELL
if(formProductId){
  jQuery.getJSON(`/recommendations/products.json?product_id=${formProductId}&limit=10`, function(response){
    if(!(response.products.length > 0)){
      productUpSell.remove();
      relatedProductsCont.remove();
      return;
    }
    let newProducts = [...response.products];
    newProducts.length > 4 ? newProducts.splice(0,4) : -1;
    if(productUpSell){
     let upSellProducts = newProducts.map((product, index) => {
       let upsellColorExist = product.options.find(name => name.name.toLowerCase() === 'color');
       let upsellColorElem = '';
       let upsellColors;
       if(upsellColorExist){
         upsellColors = upsellColorExist.values.map(value => `<option value="${value}">${value}</option>`).join(' ');
         upsellColorElem = `<div class="upsell-c__li__content-c__option-c__colors-c">
         <label class="upsell-c__li__content-c__option-c__label" for="upsell-color${index}">Select Colour</label>
         <select class="upsell-c__li__content-c__select upsell-c__li__content-c__select--color" name="upsell-color${index}" id="upsell-color${index}">
         ${upsellColors}
         </select>
        </div>`
       }
 
       let upsellSizeExist = product.options.find(name => name.name.toLowerCase() === 'size');
       let upsellSizeElement = '';
       let upsellSizes;
       if(upsellSizeExist){
         upsellSizes = upsellSizeExist.values.map(value => `<option value="${value}">${value}</option>`).join(' ');
         upsellSizeElement = `
         <div class="upsell-c__li__content-c__option-c__size-c">
           <label class="upsell-c__li__content-c__option-c__label" for="upsell-size${index}">Select Size  </label>
           <select class="upsell-c__li__content-c__select upsell-c__li__content-c__select--size" name="upsell-size${index}" id="upsell-size${index}">
           ${upsellSizes}
           </select>
         </div>
         `
       }
       
       return `
       <li class="upsell-c__li">
       <div class="upsell-c__li__flexer" data-product-id="${product.id}" data-product-handle="${product.handle}">
          <div>
          <a href="${product.url}">
            <div class="upsell-c__li__img-c">
             <img class="upsell-c__li__img-c__img" src="${product.featured_image}" alt="${product.media ? product.media[0].alt : ''}" />
            </div>
          </a>
          </div>
          <div class="upsell-c__li__content-m">
            <div class="upsell-c__li__content-c">
              <p class="upsell-c__li__content-c__title">${product.title}</p>
              <p class="upsell-c__li__content-c__price">${theme.Currency.formatMoney(product.price)}</p>
              <div class="upsell-c__li__content-c__option-c">
                ${upsellSizeElement}
                ${upsellColorElem}
              </div>
              <div class="upsell-c__li__content-c__include-c">
                <input class="upsell-c__li__content-c__include-c__input hidden" type="checkbox" name="include-me${index}" id="include-me${index}">
                <label class="upsell-c__li__content-c__include-c__label" for="include-me${index}">
                  <span class="upsell-c__li__content-c__include-c__check"><img class="upsell-c__li__content-c__include-c__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/check-cbx.svg?v=13610676340433375901" alt="Check"></span>
                  <p class="p p--2 p--include">Include</p>
                </label>
              </div>
            </div>
          </div>
       </div>
     </li>
       `
     }).join(' ');
     productUpSellAppend.insertAdjacentHTML('afterbegin', upSellProducts);
     if ($('.upsell-c__ul').hasClass('slick-initialized')) {
       $('.upsell-c__ul').slick('destroy');
     }
     $('.upsell-c__ul').slick({
       arrows:true,
       dots:false,
       infinite:true,
       slidesToShow:1,
       slidesToScroll:1,
       prevArrow:$('.upsell-c__prev'),
       nextArrow:$('.upsell-c__next'),
       responsive:[
         {
           breakpoint: 600,
           settings: {
             arrows:false
           }
         }
       ]
     });
    }
 });
}

// SIDECART REMOVE LINE ITEM
if(sideCartTbody){
  sideCartTbody.addEventListener('click', function(e){
      let targetElem = e.target;
      let target = targetElem.dataset.delete;
      if(!(target === 'true')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      let thisParent = targetElem.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
      let thisId = thisParent.dataset.itemId;
      let deleteItem = {
        id: thisId,
        quantity:0
      }
  
      $.ajax({
        method:'POST',
        url:'/cart/change.js',
        data:deleteItem,
        dataType:'json'
      })
      .done(function(res){
        thisParent.remove();
        updateSubtotal(res);
      });
    });
}

// SIDECART UPDATE QUANTITY
if(sideCartTbody){
  sideCartTbody.addEventListener('click', function(e){
    let target = e.target.dataset.quantity;
    if(!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    let targetParent = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
    let targetId = targetParent.dataset.itemId;
    let targetQuantity = e.target.parentElement.querySelector('input');
    let quantityValue = targetQuantity.value;
    let lineItemElem = targetParent.querySelector('.p--cart-total');

    if(target === 'plus'){
      quantityValue <= 98 ? targetQuantity.value = +quantityValue + 1 : -1;
    }else{
      quantityValue > 1 ? targetQuantity.value = +quantityValue - 1: -1;
    }

    let updateItem = {updates:{}};
    updateItem.updates[targetId] = targetQuantity.value;

    $.ajax({
      method:'POST',
      url:'/cart/update.js',
      data:updateItem,
      dataType:'json'
    }).done(function(res){
      let resItem = res.items.find(item => item.variant_id == targetId);
      lineItemElem.textContent = theme.Currency.formatMoney(resItem.original_line_price);
      updateSubtotal(res);
    });

  });
}

// CART UPSELL
$(document).ready(function(){
  if(cartUpsellActive){
  let getProductLineItems = [...document.querySelectorAll('tr[data-product-id]')].map(el => el.dataset.productId);
  let randomProductIndex = Math.floor(Math.random() * getProductLineItems.length);
  let appendHere = document.querySelector('.cart__upsell__grid-c');
  let cartUpsellTitle = document.querySelector('.cart__upsell__jstitle');
  jQuery.getJSON(`/recommendations/products.json?product_id=${getProductLineItems[randomProductIndex]}&limit=2`, function(res){
    if(!(res.products.length > 0)){
      cartUpsellActive.remove();
      return;
    };
    res.products[0].type !== "" ? cartUpsellTitle.textContent = res.products[0].type : cartUpsellTitle.textContent = res.products[1].type;
    let productItems = res.products.map(item => {
      return `<li class="cart__upsell__grid-c__item">
      <form action="cart/add" method="post">
        <input type="hidden" name="id" value="${item.variants[0].id}">
        <div class="cart__upsell__item-c">
          <div>
          <a class="cart__upsell__item-c__a" href="${item.url}">
           <div class="cart__upsell__item">
            <img class="cart__upsell__item__img" src="${item.featured_image}" alt="${item.variants[0].featured_image ? item.variants[0].featured_image.alt : ''}">
           </div>
          </a>
          </div>
          <div class="cart__upsell__content">
            <p class="cart__upsell__content__title">${item.title}</p>
            <p class="cart__upsell__content__price">${theme.Currency.formatMoney(item.variants[0].price)}</p>
            <div class="cart__upsell__content__input-c">
              <input class="cart__upsell__content__input" name="quantity" type="number" min="1" max="99" value="1">
              <button class="btns btns--eggplant cart__upsell__content__btn" type="submit">
               <span class="cart__upsell__content__btn__span">
                 <img class="cart__upsell__content__btn__span__img cart__upsell__content__btn__span__img--cart" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/shopping-cart.svg?v=18200075100818672203" alt="Cart"/>
                 <img class="cart__upsell__content__btn__span__img cart__upsell__content__btn__span__img--spinner" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/spinner-200-svg.svg?v=6215599837111555316" alt="Spinner"/>
                 <img class="cart__upsell__content__btn__span__img cart__upsell__content__btn__span__img--check" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/cart-check.svg?v=16050771274268337365" alt="Added"/>
               </span>
               <span class="cart__upsell__content__btn__tx">Add to cart</span>
              </button>
            </div>
          </div>
        </div>
       </form>
    </li>
      `
    }).join(' ');
    appendHere.insertAdjacentHTML('afterbegin', productItems);
    if ($('.cart__upsell__grid-c').hasClass('slick-initialized')) {
      $('.cart__upsell__grid-c').slick('destroy');
    }
    $('.cart__upsell__grid-c').slick({
      arrows:false,
      dots:false,
      infinite:true,
      slidesToShow:1,
      slidesToScroll:1,
      responsive:[
        {
          breakpoint: 2000,
          settings: 'unslick'
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow:1,
            slidesToScroll:1,
            dots: true,
            customPaging : function(slider, i) {
              return '';
            }
          }
        }
      ]
    });
  });
  }
});

// CART UPSELL AJAX
if(cartUpsellForm){
  cartUpsellForm.addEventListener('submit', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    let productForm = e.target;
    let productId = productForm.querySelector('input').value;
    let productQuantity = productForm.querySelector('input[type="number"]');
    let product = {items:[{id:productId, quantity:productQuantity.value}]};
    let appendCart = document.querySelector('.cart__table__tbody');
    let appendSideCart = document.querySelector('#side-tbody');
    let formCart = productForm.querySelector('.cart__upsell__content__btn__span__img--cart');
    let formLoading = productForm.querySelector('.cart__upsell__content__btn__span__img--spinner');
    let formCheck = productForm.querySelector('.cart__upsell__content__btn__span__img--check');
    let formButtonText = productForm.querySelector('.cart__upsell__content__btn__tx');
    let formButton = productForm.querySelector('button[type="submit"]');

    formCart.classList.add('cart__upsell__content__btn__span__img--cart--hide');
    formLoading.classList.add('cart__upsell__content__btn__span__img--spinner--show');
    formButtonText.textContent = 'Adding';
    formButton.classList.add('cart__upsell__content__btn--warm-purple');
    $.ajax({
      method:'POST',
      url:'/cart/add.js',
      data:product,
      dataType:'json'
    })
    .done(function(res){
      formLoading.classList.remove('cart__upsell__content__btn__span__img--spinner--show');
      formLoading.addEventListener('transitionend', function(){
        formCheck.classList.add('cart__upsell__content__btn__span__img--check--show');
        formButtonText.textContent = 'Added';
        formCheck.addEventListener('transitionend', function(){
          formCheck.classList.remove('cart__upsell__content__btn__span__img--check--show');
          formCheck.addEventListener('transitionend', function(){
            formCart.classList.remove('cart__upsell__content__btn__span__img--cart--hide');
            formButtonText.textContent = 'Add to Cart';
            formButton.classList.remove('cart__upsell__content__btn--warm-purple');
          });
        });
      });
      

      let elementExist = [...document.querySelectorAll(`tr[data-item-id="${res.items[0].variant_id}"]`)];
      if(elementExist.length === 0){
        let productOptions = res.items[0].options_with_values.map(option => {
          return `<p class="p p--3">${option.name}:${option.value}</p>`
        }).join(' ');
        appendCart.insertAdjacentHTML('afterbegin', `
        <tr data-item-id="${res.items[0].variant_id}" data-product-id="${res.items[0].product_id}">
        <td class="cart__table__td">
          <div class="cart__table__td__item-c">
           <div class="cart__table__td__item-c__img-c">
             <a class="cart__table__td__item-c__img-c__a" href="${res.items[0].url}"><img class="cart__table__td__item-c__img-c__img" src="${res.items[0].featured_image.url}" alt="${res.items[0].featured_image.alt}"></a>
           </div>
           <div class="cart__table__td__item-c__tx-c">
             <div class="cart__table__td__item-c__mobile-tx-c">
               <div>
                <h6 class="cart__table__td__item-c__tx-c__title">${res.items[0].title}</h6>
                ${productOptions}
               </div>
               <div class="cart__table__td__item-c__mobile-bin">
                <a href="/cart/change?line=0&quantity=0" class="cart__table__td__anc cart__table__td__anc--mobile" aria-label="Remove">
                  <div class="cart__table__td__bin-c">
                    <img src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/trash-can.svg?v=1772481377807784557" alt="Remove">
                  </div>
                 </a>
               </div>
             </div>
             <div class="cart__table__td__item-c__mobile-quantity-c">
              <p class="p p--cart-price">${theme.Currency.formatMoney(res.items[0].price)}</p>
              <div class="cart__table__td__quantity-c cart__table__td__quantity-c--mobile">
                <button class="cart__table__td__quantity-c__btn" data-mob-quantity="minus" aria-label="Reduce item quantity by one"><img class="cart__table__td__quantity-c__btn__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-minus.svg?v=7052878514306531202" alt="Reduce item quantity by one" /></button>
                <input class="cart__table__td__quantity-c__input" type="number" min="1" max="99" value="${res.items[0].quantity}" />
                <button class="cart__table__td__quantity-c__btn" data-mob-quantity="plus" aria-label="Increase item quantity by one"><img class="cart__table__td__quantity-c__btn__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-plus.svg?v=1527990585671600354" alt="Increase item quantity by one" /></button>
              </div>
              <p class="p p--cart-total">${theme.Currency.formatMoney(res.items[0].final_line_price)}</p>
             </div>
           </div>
          </div>
        </td>
        <td class="cart__table__td">
          <p class="p p--cart-price">${theme.Currency.formatMoney(res.items[0].price)}</p>
        </td>
        <td class="cart__table__td">
          <div class="cart__table__td__quantity-c cart__table__td__quantity-c--desktop">
            <button class="cart__table__td__quantity-c__btn" data-quantity="minus" aria-label="Reduce item quantity by one"><img class="cart__table__td__quantity-c__btn__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-minus.svg?v=7052878514306531202" alt="Reduce item quantity by one" /></button>
            <input class="cart__table__td__quantity-c__input" type="number" min="1" max="99" value="${res.items[0].quantity}" />
            <button class="cart__table__td__quantity-c__btn" data-quantity="plus" aria-label="Increase item quantity by one"><img class="cart__table__td__quantity-c__btn__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-plus.svg?v=1527990585671600354" alt="Increase item quantity by one" /></button>
          </div>
        </td>
        <td class="cart__table__td">
         <p class="p p--cart-total">${theme.Currency.formatMoney(res.items[0].final_line_price)}</p>
        </td>
        <td class="cart__table__td">
          <a href="/cart/change?line=0&quantity=0" class="cart__table__td__anc cart__table__td__anc--desktop" aria-label="Remove">
           <div class="cart__table__td__bin-c">
            <img src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/trash-can.svg?v=1772481377807784557" alt="Remove">
           </div>
          </a>
        </td>
      </tr>
        `);
        appendSideCart.insertAdjacentHTML('afterbegin',
      `
      <tr data-item-id="${res.items[0].variant_id}">
                    <td class="sidecart__td">
                        <div class="grids grids--sidecart">
                            <div>
                                <div class="sidecart__img-c">
                                    <a class="sidecart__img-c__a" href="${res.items[0].url}">
                                        <img class="sidecart__img-c__a__img lazyload" src="${res.items[0].featured_image.url ? res.items[0].featured_image.url : '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_80x80.gif'}" alt="${res.items[0].featured_image.alt}">
                                    </a>
                                </div>
                            </div>
                            <div>
                                <div class="sidecart__content-c">
                                    <div class="sidecart__content-c__prod-c">
                                        <h6 class="sidecart__content-c__prod-c__title">${res.items[0].title}</h6>${res.items[0].options_with_values.map(options => { `<p class="p p--3">${options.name}:${options.value}</p>`}).join(' ')}</div>
                                    <div class="sidecart__content-c__del-c">
                                        <a class="sidecart__content-c__del-c__a" data-delete="true" href="/cart/change?line=1&amp;quantity=0">
                                            <div class="sidecart__content-c__del-c__a__del-item">
                                                <img src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/trash-can.svg?v=1772481377807784557" alt="Remove">
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="sidecart__pqt">
                                    <p class="p p--cart-price">${theme.Currency.formatMoney(res.items[0].price)}</p>
                                    <div class="sidecart__pqt__price-c">
                                        <button class="sidecart__pqt__price-c__qty" data-quantity="minus" aria-label="Reduce item quantity by one"><img class="sidecart__pqt__price-c__qty__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-minus.svg?v=7052878514306531202" alt="Reduce item quantity by one"></button>
                                        <input class="sidecart__pqt__price-c__input" type="number" min="1" max="99" value="${res.items[0].quantity}">
                                        <button class="sidecart__pqt__price-c__qty" data-quantity="plus" aria-label="Increase item quantity by one"><img class="sidecart__pqt__price-c__qty__img" src="//cdn.shopify.com/s/files/1/0447/6531/5237/t/2/assets/prod-plus.svg?v=1527990585671600354" alt="Increase item quantity by one"></button>
                                    </div>
                                    <p class="p p--cart-total">${theme.Currency.formatMoney(res.items[0].final_line_price)}</p>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
      `
      );
      }else{
        elementExist.forEach(el => {
          [...el.querySelectorAll('.p--cart-total')].forEach(price => {
            price.textContent = theme.Currency.formatMoney(res.items[0].line_price);
          });
          [...el.querySelectorAll('input')].forEach(input => {
            input.value = res.items[0].quantity;
          });
        });
      }
      $.ajax({
      method:'GET',
      url:'/cart.js',
      dataType:'json'
    })
      .done(function(res){
      updateSubtotal(res);
      });
    })
    .fail(function(res){
      formLoading.classList.remove('cart__upsell__content__btn__span__img--spinner--show');
      formLoading.addEventListener('transitionend', function(e){
        formCart.classList.remove('cart__upsell__content__btn__span__img--cart--hide');
        formButtonText.textContent = 'Add to Cart';
        formButton.classList.remove('cart__upsell__content__btn--warm-purple');
      });
    });
  
  });
}

// CART QUANTITY CHANGE AJAX // CART DELETE LINE ITEM
if(cartPageTbody){
  cartPageTbody.addEventListener('click', function(e){
    if(e.target.dataset.quantity){
      e.preventDefault();
      e.stopImmediatePropagation();
      let target = e.target.dataset.quantity;
      let targetParent = e.target.parentElement.parentElement.parentElement;
      let targetId = targetParent.dataset.itemId;
      let targetQuantity = e.target.parentElement.querySelector('input');
      let quantityValue = targetQuantity.value;
      let lineItemElem = targetParent.querySelectorAll('.p--cart-total');
      if(target === 'plus'){
        quantityValue <= 98 ? targetQuantity.value = +quantityValue + 1 : -1;
      }else{
        quantityValue > 1 ? targetQuantity.value = +quantityValue - 1: -1;
      }
  
      let updateItem = {updates:{}};
      updateItem.updates[targetId] = targetQuantity.value;
      $.ajax({
        method:'POST',
        url:'/cart/update.js',
        data:updateItem,
        dataType:'json'
      }).done(function(res){
        let resItem = res.items.find(item => item.variant_id == targetId);
        lineItemElem.forEach(el => {
          el.textContent = theme.Currency.formatMoney(resItem.original_line_price);
        });
        updateSubtotal(res);
      });
    }else if(e.target.dataset.mobQuantity){
      e.preventDefault();
      e.stopImmediatePropagation();
      let target = e.target.dataset.mobQuantity;
      let targetParent = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
      let targetId = targetParent.dataset.itemId;
      let targetQuantity = e.target.parentElement.querySelector('input');
          quantityValue = targetQuantity.value;
      let lineItemElem = targetParent.querySelectorAll('.p--cart-total');
  
      if(target === 'plus'){
        quantityValue <= 98 ? targetQuantity.value = +quantityValue + 1 : -1;
      }else{
        quantityValue > 1 ? targetQuantity.value = +quantityValue - 1: -1;
      }
  
      let updateItem = {updates:{}};
      updateItem.updates[targetId] = targetQuantity.value;
      $.ajax({
        method:'POST',
        url:'/cart/update.js',
        data:updateItem,
        dataType:'json'
      }).done(function(res){
        let resItem = res.items.find(item => item.variant_id == targetId);
        lineItemElem.forEach(el => {
          el.textContent = theme.Currency.formatMoney(resItem.original_line_price);
        });
        updateSubtotal(res);
      });
    }else if(e.target.classList.contains('cart__table__td__anc--desktop')){
      e.preventDefault();
      e.stopImmediatePropagation();
      let thisParent = e.target.parentElement.parentElement;
      let thisId = thisParent.dataset.itemId;
      let deleteItem = {
        id: thisId,
        quantity:0
      }
      $.ajax({
        method:'POST',
        url:'/cart/change.js',
        data:deleteItem,
        dataType:'json'
      })
      .done(function(res){
        thisParent.remove();
        updateSubtotal(res);
      });
    }else if(e.target.classList.contains('cart__table__td__anc--mobile')){
      e.preventDefault();
      e.stopImmediatePropagation();
      let thisParent = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
      let thisId = thisParent.dataset.itemId;
      let deleteItem = {
        id: thisId,
        quantity:0
      }
      $.ajax({
        method:'POST',
        url:'/cart/change.js',
        data:deleteItem,
        dataType:'json'
      })
      .done(function(res){
        thisParent.remove();
        updateSubtotal(res);
      });
    }
  });
}

// UPDATE CART AND SIDECART SUBTOTAL PRICE
function updateSubtotal(data){
  cartSubTotalMob ? cartSubTotalMob.textContent = theme.Currency.formatMoney(data.total_price): -1;
  cartSubTotalDesk ? cartSubTotalDesk.textContent = theme.Currency.formatMoney(data.total_price) : -1;
  sideCartTotal ? sideCartTotal.textContent = theme.Currency.formatMoney(data.total_price) : -1;
  cartQuantityDisplay ? cartQuantityDisplay.textContent = data.item_count : -1;
}

// PREDICTIVE SEARCH
if(searchForm){
  searchForm.addEventListener('keyup', function(e){
    e.preventDefault();
    let inputValue = this.querySelector('.search-down__input').value;
    if(inputValue === '') return;
    jQuery.getJSON("/search/suggest.json", {
      "q": inputValue,
      "resources": {
        "type": "product",
        "limit": 5,
        "options": {
          "unavailable_products": "show",
          "fields": "title,product_type,variants.title"
        }
      }
    }).done(function(response) {
                // <p class="p p--3 p--collections-item-p">Available in ${item.variants.length} colors</p>
                // <form action="">
                //   <ul class="collections__content__item__c__ul">
                //       <input type="hidden" />
                //       ${item.variants.length > 0 ? 1 : ''}
                //     </ul>
                // </form>
        let itemArr = response.resources.results.products;
        let listItems = itemArr.map(item => {
          return `
          <li class="collections__content__item collections__content__item--search-header">
      <a class="collections__content__item__a" href="${item.url}">
          <div class="collections__content__item__img-c">
              <img class="collections__content__item__img collections__content__item__img--search-header" src="${item.featured_image.url ? item.featured_image.url : '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_190x190.gif'}" alt="${item.featured_image.alt}" />
            </div>
            <div class="collections__content__item__c">
              <h5 class="collections__content__item__c__title">${item.title}</h5>
              <h5 class="collections__content__item__c__price">${theme.Currency.formatMoney(item.price)}</h5>
            </div>
      </a>
    </li>
          `
        }).join(' ');
        searchCont.classList.add('search-down--show');
        searchDownResult.textContent = '';
        searchDownResult.insertAdjacentHTML('afterbegin', `
          <h5 class="search-down__result__title">Search results for <span class="search-down__result__tx">“${inputValue}”</span></h5>
          <ul class="grids grids--search-result-header">
          ${listItems}
          </ul>
          <div class="search-down__result__btn-c center">
          <a class="btns btns--eggplant" href="/search?q=${inputValue.replace(' ', '-')}&type=product&%5Boptions%5D%5Bprefix%5D=last">View all Results</a>
          </div>
        `);
    });
  });
}

// MOBILE SEARCH
if(mobileSearch){
  mobileSearch.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    searchMenu.classList.add('search-down-c--show');
    overlayHeader.classList.add('overlay-header--open')
  });
}

// OPEN SEARCH
if(openSearch){
  openSearch.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    searchMenu.classList.add('search-down-c--show');
  });
}

// CLOSE SEARCH
if(closeSearch){
  closeSearch.addEventListener('click', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    searchMenu ? searchMenu.classList.remove('search-down-c--show') : -1;
    overlayHeader ? overlayHeader.classList.remove('overlay-header--open'): -1;
  });
  
}

// MINICART OPEN
if (miniCartOpen) {
  miniCartOpen.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    sideCart.classList.add('sidecart--show');
    sideCart.setAttribute('tabindex', 0);
    sideCart.focus();
    overlay.classList.add('overlay--open');
    root.classList.add('overflow-hidden');
  });
}

if (miniCartClose) {
  miniCartClose.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    sideCart.classList.remove('sidecart--show');
    sideCart.setAttribute('tabindex', -1);
    rootBody.focus();
    root.classList.remove('overflow-hidden');
    overlay.classList.remove('overlay--open');
  });
}

// MOBILE MENU DROPDOWN
if(pageMobileDrop){
  pageMobileDrop.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    this.parentElement.querySelector('.page-general__mobile-menu__ul__dropdown').classList.toggle('page-general__mobile-menu__ul__dropdown--show');
  });
}

// PRODUCT RECOMMENDATIONS AJAX
async function loadProductRecommendationsIntoSection() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".recommend");
  if (productRecommendationsSection === null) { return; }
  // React section id from data attribute
  let sectionId = productRecommendationsSection.dataset.sectionId;
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".recommend").innerHTML;
      productRecommendDestroy();
      productRecommendInit();
    }
  };
  request.send();
};

// Fetching the recommendations on page load
$(document).ready(function(){
  loadProductRecommendationsIntoSection();
});

// PRODUCT PAGE RECOMMEND SLIDER
async function productRecommendInit(){
  $('.recommend-slider').slick({
    responsive:[
      {
        breakpoint: 2000,
        settings: 'unslick'
      },
      {
        breakpoint: 800,
        settings: {
          arrows:false,
          infinite:true,
          variableWidth:true,
          slidesToShow:1,
          slidesToScroll:1,
          dots: true,
          customPaging : () => ''
        }
      }
    ]
  });
}

async function productRecommendDestroy(){
  if ($('.recommend-slider').hasClass('slick-initialized')) {
    $('.recommend-slider').slick('destroy');
  } 
}

// PRODUCTS PAGE
$('.product-slider').slick({
	arrows:false,
	infinite:false,
	slidesToShow:1,
	slidesToScroll:1,
	autoplay:false,
  dots:false,
  asNavFor: '.product__item-c__img-content__ul',
  responsive:[
    {
      breakpoint: 800,
      settings: {
        dots: true,
        customPaging : function(slider, i) {
          return '';
        }
      }
    }
  ]
});

$('.product__item-c__img-content__ul').slick({
	arrows:false,
	infinite:false,
	slidesToShow:4,
  slidesToScroll:1,
	autoplay:false,
  dots:false,
  vertical:true,
  verticalSwiping:true,
  focusOnSelect:true,
  asNavFor: '.product-slider'
});

// SECTION 5 SLIDER
$('.grids--sec-5-item').slick({
	arrows:false,
	infinite:true,
	slidesToShow:1,
	slidesToScroll:1,
	autoplay:false,
	autoplaySpeed:2000,
  dots:true,
  customPaging : function(slider, i) {
    return '';
  },
  responsive:[
    {
      breakpoint: 2000,
      settings: 'unslick'
    },
    {
      breakpoint: 720,
      settings: {
        infinite: true,
        dots: true,
        arrows:false
      }
    }
  ]
});

// SECTION 3 SLIDER
$('.section-3__slider').slick({
	arrows:true,
	infinite:true,
	slidesToShow:5,
	slidesToScroll:5,
	autoplay:false,
	autoplaySpeed:2000,
  dots:true,
  prevArrow: $('.section-3__slider__prev'),
  nextArrow: $('.section-3__slider__next'),
  customPaging : function(slider, i) {
    return '';
  },
  responsive:[
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
        arrows:false
      }
    }
  ]
});

// SECTION 2 SLIDER
$('.section-2__slider').slick({
	arrows:true,
	infinite:true,
	slidesToShow:3,
	slidesToScroll:3,
	autoplay:false,
	autoplaySpeed:2000,
  dots:true,
  prevArrow: $('.section-2__prev'),
  nextArrow: $('.section-2__next'),
  customPaging : function(slider, i) {
    return '';
  },
  responsive:[
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        arrows:false,
        centerMode:true
      }
    }
  ]
});

// HEADER NAV
if(headerNav){
  headerNav.forEach(nav => {
    if(nav.hasAttribute('href')) return;
    let timeOut;
    nav.addEventListener('mouseover', function(e){
      let myThis = this;
      timeOut = setTimeout( () => headerNavShow(myThis), 400);
    });

    nav.addEventListener('mouseleave', function(){
      clearTimeout(timeOut);
    });
  });

  function closeNav(){
    headerNav.forEach(el => {
      if(el.hasAttribute('href')) return;
      el.classList.remove('header__menu__ul__a--show');
      el.dataset.toggle = 'false';
      let changeDropImg = [el.querySelector('.header__menu__ul__drop-c__drop'), el.querySelector('.header__menu__ul__drop-c__click')];
      let getId = el.dataset.target;
      let openThis = document.getElementById(getId);
      openThis.classList.remove('header-down--show');
      changeDropImg[0].classList.remove('header__menu__ul__drop-c__drop--hide');
      changeDropImg[1].classList.remove('header__menu__ul__drop-c__click--show');
    });
  }

  headerNavDown.forEach(el => {
    el.addEventListener('mouseleave', function(){
      let targetLink = document.querySelector(`a[data-target="${el.id}"]`);
      let targetImgs = [targetLink.querySelector('.header__menu__ul__drop-c__drop'), targetLink.querySelector('.header__menu__ul__drop-c__click')];
      targetImgs[0].classList.remove('header__menu__ul__drop-c__drop--hide');
      targetImgs[1].classList.remove('header__menu__ul__drop-c__click--show');
      targetLink.classList.remove('header__menu__ul__a--show');
      this.classList.remove('header-down--show');
    });
  });

}

function headerNavShow(curThis){
  let changeDropImg = [curThis.querySelector('.header__menu__ul__drop-c__drop'), curThis.querySelector('.header__menu__ul__drop-c__click')];
  let getId = curThis.dataset.target;
  let openThis = document.getElementById(getId);
  if(curThis.classList.contains('header__menu__ul__a--show')){
    return;
  }else{
    closeNav(changeDropImg);
    curThis.classList.add('header__menu__ul__a--show');
    if((curThis.dataset.toggle === 'false')){
      curThis.dataset.toggle = 'true';
      changeDropImg[0].classList.add('header__menu__ul__drop-c__drop--hide');
      changeDropImg[1].classList.add('header__menu__ul__drop-c__click--show');
    }else{
      curThis.classList.remove('header__menu__ul__a--show');
      curThis.dataset.toggle = 'false';
      changeDropImg[0].classList.remove('header__menu__ul__drop-c__drop--hide');
      changeDropImg[1].classList.remove('header__menu__ul__drop-c__click--show');
    }
    openThis.classList.toggle('header-down--show');
  }
}

// COLLECTIONS SORT AND FILTER OPEN MOBILE
if(openFilter){
  openFilter.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    document.querySelector('.c-mob-filter').classList.add('c-mob-filter--open');
    overlay.classList.add('overlay--open');
  });
}

if(openSort){
  openSort.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    document.querySelector('.c-mob-sort').classList.add('c-mob-sort--open');
    overlay.classList.add('overlay--open');
  });
}

// COLLECTIONS SORT AND FILTER CLOSE MOBILE
if(closeFilter){
  closeFilter.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    this.parentElement.classList.remove('c-mob-filter--open');
    overlay.classList.remove('overlay--open');
  });
}

if(closeSort){
  closeSort.addEventListener('click', function(e){
  e.stopImmediatePropagation();
  this.parentElement.classList.remove('c-mob-sort--open');
  overlay.classList.remove('overlay--open');
});
}

// OVERLAY
overlay.addEventListener('click', function(e){
    e.stopImmediatePropagation();
    this.classList.remove('overlay--open');
    closeSort ? closeSort.parentElement.classList.remove('c-mob-sort--open'): -1;
    closeFilter ? closeFilter.parentElement.classList.remove('c-mob-filter--open'): -1;
    sideCart ? sideCart.classList.remove('sidecart--show'): -1;
    root ? root.classList.remove('overflow-hidden') : -1;
});

// OVERLAY HEADER
overlayHeader.addEventListener('click', function(e){
  e.stopImmediatePropagation();
  this.classList.remove('overlay-header--open');
  searchMenu ? searchMenu.classList.remove('search-down-c--show') : -1;
});

// ACCORDION PAGE
if(accordionItems){
  accordionItems.forEach(accordion => {
    accordion.addEventListener('click', function(e){
      e.stopImmediatePropagation();
      let parent = this.parentElement;
      parent.classList.toggle('accordion-c__item--show');
    });
  });
}

// ACCORDION FOOTER
if(accordionFooter){
  accordionFooter.forEach(accordion => {
    accordion.addEventListener('click', function(e){
      e.stopImmediatePropagation();
      let parent = this.parentElement;
      parent.classList.toggle('footer__menu__main-mobile__li--show');
    });
  });
}

// Save existing sort parameters
Shopify.queryParams = {};
if(location.search.length) {
    for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
    }
}

// Add existing sort parameters to current URL
if (SortSelect) {
  SortSelect.addEventListener('change', function(e) {
    e.stopImmediatePropagation();
    var value = e.currentTarget.value;
    Shopify.queryParams.sort_by = value;
    Shopify.queryParams.q ? Shopify.queryParams.q = Shopify.queryParams.q.replaceAll('+', ' ') : '';
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});
}

if(mobSortAnc){
  mobSortAnc.forEach(el => {
    el.addEventListener('click', function(e){
      e.preventDefault();
      let value = this.dataset.value;
      Shopify.queryParams.sort_by = value;
      Shopify.queryParams.q ? Shopify.queryParams.q = Shopify.queryParams.q.replaceAll('+', ' ') : '';
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  });
}

$('.collections__content__item__img-c__swatch-imgc').slick({
	arrows:false,
	infinite:true,
	slidesToShow:1,
	slidesToScroll:1,
	autoplay:false,
  dots:false,
  customPaging : () => ''
});

if(productSwatch){
  productSwatch.forEach((el) => {
    el.addEventListener('click', function(e){
      let dataColorTarget = this.querySelector('[data-target-color]').dataset.targetColor;
      let parent = this.parentElement.parentElement;
      let dataImage = parent.querySelector(`[data-color="${dataColorTarget}"]`);
      let dataImageIndex;
      if(!dataImage) return;
      if(!dataImage.dataset.imageExist) return;
      dataImageIndex = dataImage.dataset.colorIndex;
      $(parent.querySelector('.collections__content__item__img-c__swatch-imgc')).slick('slickGoTo', dataImageIndex, false);
    });
  })
}

if(showMoreSwatches){
  showMoreSwatches.forEach(el => {
    el.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      
      let parent = this.parentElement;
      let allHidden = [...parent.querySelectorAll('.collections__content__item__c__li--hidden')];
      allHidden.forEach((el, index) => {
        if(index < 4){
          el.classList.remove('collections__content__item__c__li--hidden');
        }
      });
    });
  })
}

